// extracted by mini-css-extract-plugin
export default {"imageIndex":"PhotoPanelHeader_imageIndex__B2Q8Z"};